import { Form, Modal, Input, Button } from 'antd';
import React from 'react';
import { observer } from 'mobx-react';
import { CONFIRM_CHANGE_PASSWORD_RULE } from '@/constants/rules.constants';

interface ComponentProps {
  handleChangePassword?: any;
  handleCancel?: any;
}

const ChangePasswordForm = (props: ComponentProps) => {
  const { handleChangePassword, handleCancel } = props;

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  return (
    <Modal
      title="Change Password"
      visible={true}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button
          type="primary"
          form="change-password"
          key="submit"
          htmlType="submit"
        >
          Submit
        </Button>,
        <Button onClick={handleCancel}>Cancel</Button>,
      ]}
    >
      <Form
        name="change-password-form"
        className="form change-password"
        id="change-password"
        {...formItemLayout}
        onFinish={handleChangePassword}
      >
        <Form.Item
          name="oldPassword"
          label="Old password"
          rules={[
            {
              required: true,
              message: 'Please input your old password!',
            },
          ]}
        >
          <Input.Password placeholder="Old password" />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="New password"
          rules={[
            {
              required: true,
              message: 'Please input your new password!',
            },
          ]}
        >
          <Input.Password placeholder="New password" />
        </Form.Item>
        <Form.Item
          name="confirm"
          label="Confirm Password"
          dependencies={['newPassword']}
          hasFeedback
          rules={CONFIRM_CHANGE_PASSWORD_RULE}
        >
          <Input.Password placeholder="Confirm new password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default observer(ChangePasswordForm);
